import React from 'react'

import { Feature, RequireRole } from 'components/auth/features'
import { Sidebar } from 'components/layouts/Sidebar/Sidebar'

import { DEFAULT_JOBS_QUERY_PARAMS } from 'constants/projects'
import { toProjects } from 'ducks/router'
import { getLinkActions, getNavigationLinks } from './model'

export const DashboardSidebar = ({ onToggle, isToggled }) => {
  const links = getNavigationLinks()

  return (
    <Sidebar isCollapsed={!isToggled}>
      <Sidebar.Logo
        redirectTo={toProjects(null, null, DEFAULT_JOBS_QUERY_PARAMS)}
        isCollapsed={!isToggled}
      />
      <Sidebar.ToggleButton {...{ onToggle }} />
      <Sidebar.Navigation>
        {links.map(
          ({ feature, role, icon, label, type, isActive, isExact }) => {
            const to = getLinkActions(type)
            const item = (
              <Sidebar.NavigationItem
                isCollapsed={!isToggled}
                {...{ icon, label, to, isActive, isExact }}
              />
            )

            if (feature) {
              return (
                <Feature key={label} name={feature}>
                  {item}
                </Feature>
              )
            }
            if (role) {
              return (
                <RequireRole key={label} role={role}>
                  {item}
                </RequireRole>
              )
            }
            return <React.Fragment key={label}>{item}</React.Fragment>
          },
        )}
      </Sidebar.Navigation>
    </Sidebar>
  )
}
